// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRenewalJson } from './IRenewalJson';
import {
    IRenewalJsonFromJSON,
    IRenewalJsonFromJSONTyped,
    IRenewalJsonToJSON,
    IRenewalJsonToJSONTyped,
} from './IRenewalJson';

/**
 * 
 * @export
 * @interface IRenewalRecordDto
 */
export interface IRenewalRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordDto
     */
    org_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordDto
     */
    org_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IRenewalRecordDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordDto
     */
    status?: IRenewalRecordDtoStatusEnum;
    /**
     * 
     * @type {IRenewalJson}
     * @memberof IRenewalRecordDto
     */
    renewal_json?: IRenewalJson;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordDto
     */
    plan_renewal_note?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalRecordDto
     */
    health_plan_renewal_note?: string;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalRecordDtoStatusEnum {
    NEW = 'NEW',
    REQUESTED = 'REQUESTED',
    CANCELED = 'CANCELED',
    ACTIVE = 'ACTIVE',
    PROCESSING = 'PROCESSING',
    COMPLETE = 'COMPLETE',
    RESOLVED = 'RESOLVED'
}


/**
 * Check if a given object implements the IRenewalRecordDto interface.
 */
export function instanceOfIRenewalRecordDto(value: object): value is IRenewalRecordDto {
    return true;
}

export function IRenewalRecordDtoFromJSON(json: any): IRenewalRecordDto {
    return IRenewalRecordDtoFromJSONTyped(json, false);
}

export function IRenewalRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'renewal_json': json['renewal_json'] == null ? undefined : IRenewalJsonFromJSON(json['renewal_json']),
        'plan_renewal_note': json['plan_renewal_note'] == null ? undefined : json['plan_renewal_note'],
        'health_plan_renewal_note': json['health_plan_renewal_note'] == null ? undefined : json['health_plan_renewal_note'],
    };
}

export function IRenewalRecordDtoToJSON(json: any): IRenewalRecordDto {
    return IRenewalRecordDtoToJSONTyped(json, false);
}

export function IRenewalRecordDtoToJSONTyped(value?: IRenewalRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'org_id': value['org_id'],
        'org_path': value['org_path'],
        'plan_year_id': value['plan_year_id'],
        'status': value['status'],
        'renewal_json': IRenewalJsonToJSON(value['renewal_json']),
        'plan_renewal_note': value['plan_renewal_note'],
        'health_plan_renewal_note': value['health_plan_renewal_note'],
    };
}

